import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appRoutes } from './app.routes';
import {
  provideTranslation,
} from '@flexbenefits-ui/services';
import {
  provideEnvironment,
  authInterceptor,
  cacheControlInterceptor,
  contentTypeInterceptor,
  errorLoggingInterceptor,
  timeoutInterceptor,
} from '@flexbenefits-ui/data-access-api';
import { environment } from '../environments/environment.development';
import { appInitializerFactory } from './startup/app-initializer.factory';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        cacheControlInterceptor,
        contentTypeInterceptor,
        errorLoggingInterceptor,
        timeoutInterceptor(30000),
      ])
    ),
    provideTranslation(),
    provideEnvironment(environment),
    // Initialize all services before app starts
    provideAppInitializer(() => {
      return appInitializerFactory()();
    })
  ],
};
